import { SearchRequest } from "@/types/search.definition";
import webClient from "../config/api.config";
import { FacilityRequest, FacilityUpdate } from "../types/facility.definition";

export function getHealthcareFacilityById(id: number) {
  return webClient.request({
    method: "get",
    url: `/healthcare-facilities/${id}`,
  });
}

export function getFacilityStaffStats(id: number) {
  return webClient.request({
    method: "get",
    url: `/healthcare-facilities/${id}/staff/stats`,
  });
}

export async function getHealthcareFacilities() {
  return webClient.request({
    method: "get",
    url: `/healthcare-facilities`,
  });
}
export async function searchHealthcareFacilities() {
  return webClient.request({
    method: "get",
    url: `/healthcare-facilities/search`,
  });
}
export function updateHealthcareFacility(data: FacilityUpdate, id: number) {
  return webClient.request({
    method: "put",
    url: `/healthcare-facilities/${id}`,
    data,
  });
}

export function createHealthcareFacility(data: FacilityRequest) {
  return webClient.request({
    method: "post",
    url: `/healthcare-facilities`,
    data,
  });
}

// MED-1443: DELETE is the soft-disable on this resource (it flips `disabled`,
// it does not drop the row); PUT /restore is its counterpart.
export function disableHealthcareFacility(id: number) {
  return webClient.request({
    method: "delete",
    url: `/healthcare-facilities/${id}`,
  });
}

export function restoreHealthcareFacility(id: number) {
  return webClient.request({
    method: "put",
    url: `/healthcare-facilities/${id}/restore`,
  });
}

export function getHealthcareFacilityDoctors(facilityId: number) {
  return webClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/doctors`,
  });
}

export function getHealthcareFacilityPatients(facilityId: number) {
  return webClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/patients`,
  });
}

export function getHealthcareFacilityAppointments(facilityId: number) {
  return webClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/appointments`,
  });
}
export function getHealthcareFacilityStatistics(facilityId: number) {
  return webClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/statistics`,
  });
}

export function requestSearchHealthFacilities(data: SearchRequest) {
  return webClient.request({
    method: "post",
    url: `/healthcare-facilities/search`,
    data,
  });
}

export function getHealthcareFacilityManagers(facilityId: number) {
  return webClient.request({
    method: "get",
    url: `/healthcare-facilities/${facilityId}/managers`,
  });
}
